import React, {Fragment} from "react";
import {Dialog, Transition} from "@headlessui/react";
import Spinner from "@/components/tailwindComponents/Spinner";
import PersianDate from "@/components/utils/PersianDate";
import jMoment from "moment-jalaali";
import Link from "next/link";

interface FilterProps {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
}

const FiltersWrapper: React.FC<FilterProps> = ({children, isOpen, onClose}) => {
    return (
        <>
            <div
                className="p-2 w-1/4 hidden lg:block border-2 border-gray-200 bg-white rounded-sm h-full overflow-y-auto sticky top-36">
                <div className="space-y-6">
                    <div className="font-bold p-1">فیلترها:</div>
                    <div className="space-y-6 px-2">
                        {children}
                    </div>
                </div>
            </div>
            <div className="block lg:hidden">
                <Transition.Root show={isOpen} as={Fragment}>
                    <Dialog as="div" onClose={onClose} className="relative z-0 lg:hidden">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed backdrop-blur-[2px] inset-0 bg-opacity-40 transition-opacity"/>
                        </Transition.Child>

                        <div className="fixed bottom-16 inset-0 flex items-end justify-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="translate-y-full"
                                enterTo="translate-y-0"
                                leave="ease-in duration-200"
                                leaveFrom="translate-y-0"
                                leaveTo="translate-y-full"
                            >
                                <Dialog.Panel
                                    className="w-full bg-white border-t border-gray-400 overflow-y-auto">
                                    <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mt-2 mb-1"/>
                                    <div className="flex items-center justify-between px-4 pb-2">
                                        <Dialog.Title
                                            className="font-bold text-black p-1 text-base">
                                            فیلترها
                                        </Dialog.Title>
                                        <button
                                            onClick={onClose}
                                            className="text-gray-500 scale-125 hover:text-gray-800 transition"
                                            aria-label="بستن اعلان‌ها"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                    <div className="space-y-8 mx-8 py-2">
                                        {children}
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
        </>
    )
}

export default FiltersWrapper;